export default __webpack_public_path__ + "static/media/health-insurance.b9acb39c.jpg";